module.exports = __webpack_public_path__ + "static/media/Y1.869bee80.png";